import React from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../../../components/ui/Button';

const ProductHeroSection = () => {
  const navigate = useNavigate();

  return (
    <section style={{
      position: 'relative',
      minHeight: '100vh',
      width: '100%',
      backgroundColor: '#242423',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      padding: '0 1rem'
    }}>
      {/* Background Image Layer */}
      <div style={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundImage: 'url(/assets/images/Product-1770321086615.png)',
        backgroundSize: 'cover',
        backgroundPosition: 'center top',
        backgroundRepeat: 'no-repeat',
        opacity: 0.12,
        zIndex: 0
      }} />
      {/* Gradient Fade Overlay */}
      <div style={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: 'linear-gradient(to bottom, transparent 0%, rgba(36, 36, 35, 0.4) 30%, rgba(36, 36, 35, 0.8) 60%, #242423 85%)',
        zIndex: 1
      }} />
      {/* Content Container */}
      <div style={{
        position: 'relative',
        zIndex: 2,
        maxWidth: '56rem',
        margin: '0 auto',
        textAlign: 'center',
        padding: '0 1rem'
      }}>
        {/* Badge */}
        <div style={{
          fontSize: '0.75rem',
          fontWeight: '600',
          color: '#4FB3B8',
          marginBottom: '1rem',
          letterSpacing: '0.1em',
          textTransform: 'uppercase'
        }}>
          SLEEVE ORCHESTRATION PLATFORM
        </div>

        {/* Main Title */}
        <h1 style={{
          fontSize: 'clamp(2rem, 5vw, 3.5rem)',
          fontWeight: '700',
          color: '#E8EDDF',
          marginBottom: '1.5rem',
          lineHeight: '1.2'
        }}>
          Unified Agent Orchestration for Industrial Systems
        </h1>

        {/* Description */}
        <p style={{
          fontSize: 'clamp(1rem, 2vw, 1.25rem)',
          color: '#9CA3AF',
          maxWidth: '48rem',
          margin: '0 auto 2rem',
          lineHeight: '1.6'
        }}>
          Sleeve is an intelligent orchestration framework that deploys and coordinates agents, tools, and humans across the cloud-edge continuum. Real-time, context-aware decisions at the point of data—coordinating autonomous agents across cloud-edge infrastructure.
        </p>

        {/* Bullet Points */}
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: '0.75rem',
          marginBottom: '2.5rem'
        }}>
          {[
            'Agent orchestration across distributed environments',
            'Hardware-agnostic deployment architecture',
            'Human-in-the-loop adaptive workflows'
          ]?.map((text, index) => (
            <div key={index} style={{
              display: 'flex',
              alignItems: 'center',
              gap: '0.75rem'
            }}>
              <div style={{
                width: '8px',
                height: '8px',
                borderRadius: '50%',
                backgroundColor: '#4FB3B8',
                flexShrink: 0
              }} />
              <p style={{
                fontSize: 'clamp(0.875rem, 1.5vw, 1rem)',
                color: '#E8EDDF',
                margin: 0
              }}>
                {text}
              </p>
            </div>
          ))}
        </div>

        {/* CTA Buttons */}
        <div style={{
          display: 'flex',
          flexDirection: 'row',
          flexWrap: 'wrap',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '1rem'
        }}>
          <Button
            variant="default"
            size="lg"
            iconName="Video"
            iconPosition="left"
            style={{
              backgroundColor: '#4FB3B8',
              color: '#242423',
              border: 'none',
              minWidth: '280px'
            }}
            onClick={() => navigate('/contact')}
          >
            Request a Live Platform Demo
          </Button>
          <Button
            variant="outline"
            size="lg"
            iconName="FileText"
            iconPosition="left"
            style={{
              backgroundColor: 'transparent',
              color: '#E8EDDF',
              borderColor: '#4FB3B8',
              minWidth: '200px'
            }}
            onClick={() => window.open('https://docs.sleeve.dev', '_blank')}
          >
            Explore the Docs
          </Button>
        </div>
      </div>
    </section>
  );
};

export default ProductHeroSection;